module.exports = [{"id":"jw_red","brand_id":"jw","name":"Red Label","images":{"backgrounds":[],"bottles":[]}},{"id":"jw_black","brand_id":"jw","name":"Black Label","images":{"backgrounds":[],"bottles":[]}},{"id":"jw_double_black","brand_id":"jw","name":"Double Black","images":{"backgrounds":[],"bottles":[]}},{"id":"jw_gold","brand_id":"jw","name":"Gold Label","images":{"backgrounds":[],"bottles":[]}},{"id":"jw_green","brand_id":"jw","name":"Green Label","images":{"backgrounds":[],"bottles":[]}},{"id":"jw_platinum","brand_id":"jw","name":"18 Year Old","images":{"backgrounds":[],"bottles":[]}}]


//////////////////
// WEBPACK FOOTER
// ./src/data/products.json
// module id = 207
// module chunks = 0